import { render, staticRenderFns } from "./AppIconStretch.vue?vue&type=template&id=354ba2d1&scoped=true&"
import script from "./AppIconStretch.vue?vue&type=script&lang=js&"
export * from "./AppIconStretch.vue?vue&type=script&lang=js&"
import style0 from "./AppIconStretch.vue?vue&type=style&index=0&id=354ba2d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ba2d1",
  null
  
)

export default component.exports